export const OnboardingLivesScreenPath = "/onboarding-lives";

export enum OnboardingLivesTab {
  Lives = "lives",
  Plans = "plans",
}

export function onboardingLivesPathOf(tab: OnboardingLivesTab): string {
  return tab === OnboardingLivesTab.Plans
    ? `${OnboardingLivesScreenPath}?tab=${tab}`
    : OnboardingLivesScreenPath;
}
export const OnboardingLiveDetailScreenPath =
  "/onboarding-lives/:onboardingLiveId";
export const OnboardingLivePlanScreenPath = "/onboarding-lives/plans/:intentId";
export const OnboardingLiveStatisticsScreenPath =
  "/onboarding-lives/statistics";

export function onboardingLiveDetailPathOf(onboardingLiveId: string): string {
  return OnboardingLiveDetailScreenPath.replace(
    ":onboardingLiveId",
    onboardingLiveId,
  );
}

export function onboardingLivePlanPathOf(intentId: string): string {
  return OnboardingLivePlanScreenPath.replace(":intentId", intentId);
}

export const CreateOnboardingLivePdfScreenPath = "/onboarding-live-pdfs/new";
export const EditOnboardingLivePdfScreenPath =
  "/onboarding-live-pdfs/:userGroupId";

export function editOnboardingLivePdfPathOf(userGroupId: string): string {
  return EditOnboardingLivePdfScreenPath.replace(
    ":userGroupId",
    encodeURIComponent(userGroupId),
  );
}
